export default __webpack_public_path__ + "static/media/attractions4.47f868c8.avif";